import {ReportFileReqRes} from './ReportFileReqRes.model';
import {ReportFAQReqRes} from './reportFAQReqRes.model';

export abstract class HoldingReportReqRes {
  public id: number;
  public periodStartDate: Date;
  public periodEndDate: Date;
  public publishDate: Date;
  public grossPotentialRent: number;
  public vacancyLoss: number;
  public delinquentRent: number;
  public income: number;
  public expenses: number;
  public assetManagementFees: number;
  public netOperatingIncome: number;
  public debtService: number;
  public capitalExpenditures: number;
  public netIncome: number;
  public vacancyRate: number;
  public delinquentRate: number;
  public operatingExpense: number;
  public summary: string;
  assetId: number;
  attachments: ReportFileReqRes[];
  faQs: ReportFAQReqRes[];
  totalCapitalization: number;
  totalEquityInvestedToDate: number;
  totalReturnsToDate: number;
  totalInvestorEquity: number;
  gpEquityFromTotalEquity: number;
  estimatedMarketValue: number;
}
